"use client";

import { motion } from "framer-motion";
import { SearchX } from "lucide-react";
import HoverArrow from "@/components/shared/HoverArrow";

export default function EmptyState({ onReset }: { onReset: () => void }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="card-flat col-span-full flex flex-col items-center text-center gap-4 bg-paper-deep/40 px-6 py-16"
    >
      <span className="w-14 h-14 rounded-2xl bg-accent-soft text-accent flex items-center justify-center">
        <SearchX size={26} aria-hidden="true" />
      </span>
      <div className="flex flex-col gap-1.5">
        <h3 className="font-display font-bold text-xl text-ink">
          Keine Universität gefunden
        </h3>
        <p className="text-ink-soft text-sm leading-relaxed max-w-sm">
          Für deine aktuelle Auswahl gibt es keine Treffer. Passe deine Filter an
          oder setze sie zurück.
        </p>
      </div>
      <button
        onClick={onReset}
        className="group mt-2 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-accent text-paper text-sm font-semibold hover:bg-accent-deep transition-colors duration-200 cursor-pointer"
      >
        Filter zurücksetzen
        <HoverArrow />
      </button>
    </motion.div>
  );
}
